export const PAYMENTS_DONT_SHOW_AGAIN_TOKEN = "PAYMENTS_DONT_SHOW_AGAIN";
